import { HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';
import isEmpty from 'lodash-es/isEmpty';
import { Observable, of } from 'rxjs';
import { catchError, concatAll, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import { headersAllTenantsAppend } from '../../../classes/utils/utils';
import { MyUtilsApi } from '../../../sdk';

@Pipe({
  name: 'pictureLink',
})
export class PictureLinkPipe implements PipeTransform {
  constructor(private utilsApi: MyUtilsApi) {}

  transform(filename?: string | null, convert?: string, bigLoader = false): Observable<string> {
    if (isNil(filename) || isEmpty('' + filename)) return of('');

    function customHeaders(headers: HttpHeaders) {
      return headersAllTenantsAppend(headers).append('ngsw-bypass', '1');
    }

    return of(filename).pipe(
      filter(fname => !isEmpty(oc(fname)(''))),
      distinctUntilChanged(),
      // tap(console.log),
      switchMap(fname =>
        of(
          of(bigLoader ? '/assets/images/big-loader.gif' : '/assets/images/loader.gif'),
          this.utilsApi
            .getPictureLink(fname, convert, customHeaders)
            .pipe(catchError(err => of('/assets/images/none.png'))),
        ).pipe(concatAll()),
      ),
    );
  }
}
